export enum TERM {
  hourly,
  fixed,
  milestone
}
